import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, LocationFullDTO } from '../../../../services/api/api';
import { ActivatedRoute } from '@angular/router';
import { ErrorService } from '../../../../services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { PermissionService } from '../../../../services/permission.service';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-location-settings',
  templateUrl: './location-settings.component.html',
  styleUrls: ['./location-settings.component.scss'],
  standalone: false,
})
export class LocationSettingsComponent implements OnInit {
  locationId: number;
  location: LocationFullDTO;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.activatedRoute.parent.params.subscribe(params => {
      this.locationId = +params.locationID;
      this.api
        .ss_fm_Location_retrieveById(this.locationId)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: (e: LocationFullDTO) => {
            this.location = e;
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    });
  }
}
